/**
 * Moazzam Khan Couture — Animations, Infinite Scroll & Sale Scroller Loop
 */

document.addEventListener('DOMContentLoaded', function () {
  // -------------------------------------------------------------
  // 1. SCROLL REVEAL ANIMATIONS
  // -------------------------------------------------------------
  const revealElements = document.querySelectorAll(
    '.product-card, .mk-card, .category-card, .sale-item, .section-title, .mk-section-title'
  );

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('mk-is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.08,
      }
    );

    revealElements.forEach((el) => {
      el.classList.add('mk-reveal-on-scroll');
      revealObserver.observe(el);
    });
  } else {
    revealElements.forEach((el) => el.classList.add('mk-is-revealed'));
  }

  // -------------------------------------------------------------
  // 2. INFINITE SCROLL FOR COLLECTION PAGES (Zainab Chottani Style)
  // -------------------------------------------------------------
  const collectionGrid =
    document.querySelector('.product-list') ||
    document.querySelector('.mk-collection__grid');

  // Only run the custom infinite-scroll on the legacy MK collection section.
  // Prestige's native collection section already handles pagination, facets, and filtering.
  if (collectionGrid && !document.querySelector('.shopify-section--main-collection')) {
    let isLoading = false;
    let nextUrl = null;

    const findNextUrl = () => {
      const nextLink = document.querySelector(
        '.pagination a[rel="next"], a.pagination__link[rel="next"], .pagination__next'
      );
      return nextLink ? nextLink.href : null;
    };

    nextUrl = findNextUrl();

    const normalizeNextUrl = (url) => {
      if (!url) return null;
      try {
        const parsed = new URL(url, window.location.href);
        return parsed.origin === window.location.origin ? parsed.href : null;
      } catch (error) {
        return null;
      }
    };

    nextUrl = normalizeNextUrl(nextUrl);

    // Hide manual pagination container if infinite scroll is active
    const paginationContainer = document.querySelector('.pagination, .mk-pagination');
    if (paginationContainer && nextUrl) {
      paginationContainer.style.opacity = '0.4';
    }

    const loadNextPage = async () => {
      if (isLoading || !nextUrl) return;
      isLoading = true;

      try {
        const fetchedUrl = nextUrl;
        const response = await fetch(fetchedUrl);
        if (!response.ok) return;

        const htmlText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');

        const newGrid =
          doc.querySelector('.product-list') ||
          doc.querySelector('.mk-collection__grid');

        if (newGrid) {
          const newProducts = newGrid.querySelectorAll(
            '.product-card, .mk-card, article'
          );

          newProducts.forEach((prod) => {
            prod.classList.add('mk-reveal-on-scroll', 'mk-is-revealed');
            collectionGrid.appendChild(prod);
          });

          // Update next URL for subsequent scroll
          const newNextLink = doc.querySelector(
            '.pagination a[rel="next"], a.pagination__link[rel="next"], .pagination__next'
          );
          nextUrl = normalizeNextUrl(newNextLink ? newNextLink.href : null);

          // Keep the address bar aligned with the latest loaded collection page
          // without creating a new browser-history entry for every batch.
          if (nextUrl) {
            try {
              window.history.replaceState(window.history.state, '', fetchedUrl);
            } catch (error) {
              // Ignore environments where history replacement is restricted.
            }
          }

          if (!nextUrl && paginationContainer) {
            paginationContainer.style.display = 'none';
          }
        }
      } catch (err) {
        console.error('Error fetching next page products:', err);
      } finally {
        isLoading = false;
      }
    };

    // Throttled scroll listener for loading next products near bottom.
    let scrollCheckScheduled = false;
    const checkScrollPosition = () => {
      scrollCheckScheduled = false;
      if (!nextUrl || isLoading) return;

      const scrollPosition = window.innerHeight + window.scrollY;
      const pageThreshold = document.body.offsetHeight - 900;

      if (scrollPosition >= pageThreshold) {
        loadNextPage();
      }
    };

    window.addEventListener(
      'scroll',
      function () {
        if (scrollCheckScheduled) return;
        scrollCheckScheduled = true;
        window.requestAnimationFrame(checkScrollPosition);
      },
      { passive: true }
    );
  }

  // -------------------------------------------------------------
  // 3. CONTINUOUS INFINITE SALE SCROLLER (pic 1 -> pic 2 -> pic 3 -> pic 1)
  // -------------------------------------------------------------
  const saleSliders = document.querySelectorAll('.sale-slider');

  saleSliders.forEach((slider) => {
    const sectionId = slider.id.replace('saleSlider-', '');
    const prevBtn = document.getElementById('salePrevBtn-' + sectionId);
    const nextBtn = document.getElementById('saleNextBtn-' + sectionId);

    if (!slider) return;

    function getItemWidth() {
      const item = slider.querySelector('.sale-item');
      return item ? item.offsetWidth + 16 : 280;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        const itemWidth = getItemWidth();
        const maxScroll = slider.scrollWidth - slider.clientWidth;

        if (slider.scrollLeft >= maxScroll - 15) {
          // Seamless loop back to first item
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          slider.scrollBy({ left: itemWidth * 2, behavior: 'smooth' });
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        const itemWidth = getItemWidth();

        if (slider.scrollLeft <= 15) {
          // Loop to end
          slider.scrollTo({ left: slider.scrollWidth, behavior: 'smooth' });
        } else {
          slider.scrollBy({ left: -itemWidth * 2, behavior: 'smooth' });
        }
      });
    }

    // Auto-scroll loop every 4.5 seconds. Pause while the shopper is interacting,
    // then resume when interaction ends.
    let autoPlayInterval = null;

    const advanceSaleSlider = () => {
      if (!slider) return;
      const itemWidth = getItemWidth();
      const maxScroll = slider.scrollWidth - slider.clientWidth;

      if (maxScroll <= 0) return;

      if (slider.scrollLeft >= maxScroll - 15) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        slider.scrollBy({ left: itemWidth, behavior: 'smooth' });
      }
    };

    const stopAutoPlay = () => {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
    };

    const startAutoPlay = () => {
      stopAutoPlay();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      autoPlayInterval = setInterval(advanceSaleSlider, 4500);
    };

    startAutoPlay();
    slider.addEventListener('mouseenter', stopAutoPlay);
    slider.addEventListener('mouseleave', startAutoPlay);
    slider.addEventListener('touchstart', stopAutoPlay, { passive: true });
    slider.addEventListener('touchend', startAutoPlay, { passive: true });
  });
});
